import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

import * as styles from './RequestExistsModalWindow.css';
import { ResultModalWindow, useResponsiveText } from '../ResultModalWindow';

export interface IRequestExistsModalWindowProps {
  open: boolean;
  onClose: () => void;
}

export const RequestExistsModalWindow: React.FC<IRequestExistsModalWindowProps> = ({ open, onClose }) => {
  const UIText = useResponsiveText();

  return (
    <ResultModalWindow
      open={open}
      textContent={
        <div className={styles['text']}>
          <UIHeading2 textAlign="center">Вы уже отправили заявку</UIHeading2>
          <UIText textAlign="center">Скоро с вами свяжемся</UIText>
        </div>
      }
      onClose={onClose}
    />
  );
};
